import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontFamilies, palette,
}: Theme) => ({
  title: {
    margin: '0 0 4rem',
    fontFamily: fontFamilies.primary,
    fontSize: '1.25rem',
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      fontSize: '1.75rem',
    },
  },
  pieImage: {
    textAlign: 'center',
    marginBottom: 48,
    [breakpoints.up('md')]: {
      marginBottom: 64,
    },
  },
  veevaNumber: {
    position: 'absolute',
    left: '0.25rem',
    top: '0.25rem',
    color: palette.grey[200],
    fontSize: '0.625rem',
    lineHeight: 1.1,
  },
}));
